import { QueryClient } from '@tanstack/react-query';
import { QUERY_KEY } from 'app/business-logic/services/query-key';

export function invalidateNoiseEventQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.noiseEventsByAlertIdBase],
  });
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.noiseEventsByAlertIdResourceGroups],
  });
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.noiseEventsByAlertIdClassification],
  });
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.noiseEventHistoryBase],
  });
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.noiseEventHistoryResourceGroups],
  });
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.noiseEventHistoryClassification],
  });
}
